import { useQuery } from '@tanstack/react-query';
import { UseQueryOptions } from '@tanstack/react-query';
import { DashboardService } from '../dashboard.service';

export const useGetDashboardIndicators = (
	options?: Omit<
		UseQueryOptions<Dashboard.Indicators, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['indicators'],
		queryFn: () => DashboardService.get(),
		refetchOnWindowFocus: false,
		...options,
	});
};
